export default __webpack_public_path__ + "static/media/dashboard.25e1b5ce.svg";